(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dollie-product-preview"]) return;
  try {
    
const initDollieBuying = () => {
  const root = document.querySelector('.dbp-pdp');
  if (!root || root.dataset.buyReady) return;
  root.dataset.buyReady = 'true';
  const info = root.querySelector('[data-dbp-info]');
  const variants = JSON.parse(root.querySelector('[data-dbp-variants]').textContent);
  const button = info.querySelector('button[name="add"]');
  const bar = document.querySelector('.dbp-mobile-buy');
  const mobile = window.matchMedia('(max-width:767px)');
  const update = (id, writeUrl) => {
    const variant = variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    info.querySelector('.dbp-price').textContent = variant.price;
    info.querySelector('[data-dbp-unit]').textContent = variant.unit;
    info.querySelector('[data-dbp-bottle]').textContent = variant.bottle + ' je Flasche' + (variant.count > 1 ? ' · ' + variant.count + ' Flaschen im Set' : '');
    info.querySelectorAll('input[name="id"]').forEach(input => { input.value = variant.id; input.disabled = !variant.available; });
    info.querySelectorAll('[data-dbp-variant]').forEach(input => { input.checked = input.value === String(variant.id); });
    button.disabled = !variant.available;
    button.querySelector('.single-add-to-cart-button--text').textContent = variant.available ? theme.variantStrings.addToCart : theme.variantStrings.soldOut;
    button.classList.toggle('sold-out', !variant.available);
    const stock = info.querySelector('.dbp-stock');
    if (stock) {
      stock.hidden = false;
      stock.innerHTML = '<span aria-hidden="true"></span>';
      stock.append(document.createTextNode(variant.available && variant.stock > 0 ? 'Auf Lager - In 1-3 Werktagen bei dir.' : variant.available ? 'Bestellbar – Lieferzeit bitte anfragen.' : 'Aktuell ausverkauft.'));
    }
    bar.querySelector('[data-dbp-sticky-price]').textContent = variant.price;
    bar.querySelector('[data-dbp-sticky-title]').textContent = variant.title;
    if (writeUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    refresh();
  };
  const refresh = () => {
    const rect = button.getBoundingClientRect();
    const price = info.querySelector('.dbp-price').getBoundingClientRect();
    const panelOpen = document.body.classList.contains('open-cc') || !!document.querySelector('.side-panel.active');
    bar.hidden = !mobile.matches || price.top > innerHeight || (rect.top < innerHeight && rect.bottom > 0) || panelOpen;
    if (document.body.classList.contains('dbp-mobile-buy-active') === bar.hidden) document.body.classList.toggle('dbp-mobile-buy-active', !bar.hidden);
    const stickyButton = bar.querySelector('button');
    stickyButton.disabled = button.disabled || button.classList.contains('loading');
    document.documentElement.style.setProperty('--dbp-teaser-top', Math.round(document.querySelector('#main-content').getBoundingClientRect().top + scrollY + 8) + 'px');
  };
  root.addEventListener('change', event => { if (event.target.matches('[data-dbp-variant]')) update(event.target.value, true); });
  window.addEventListener('popstate', () => update(new URL(location.href).searchParams.get('variant') || variants[0].id, false));
  bar.querySelector('button').addEventListener('click', () => { if (!button.disabled && !button.classList.contains('loading')) button.click(); });
  window.addEventListener('scroll', refresh, {passive:true});
  window.addEventListener('resize', refresh);
  new ResizeObserver(refresh).observe(root);
  new MutationObserver(refresh).observe(button, {attributes:true,attributeFilter:['disabled','class']});
  new MutationObserver(refresh).observe(document.body, {attributes:true,attributeFilter:['class']});
  update(info.querySelector('[data-dbp-variant]:checked').value, false);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDollieBuying); else initDollieBuying();
document.addEventListener('shopify:section:load', initDollieBuying);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dollie-product-story"] && !Shopify.designMode) return;
  try {
    
const initTruffleDescriptions = () => {
  document.querySelectorAll('.dtr-full-description').forEach(details => {
    if (details.dataset.responsiveReady) return;
    details.dataset.responsiveReady = 'true';
    const desktop = window.matchMedia('(min-width: 768px)');
    details.open = desktop.matches;
    desktop.addEventListener('change', event => { details.open = event.matches; });
  });
};
initTruffleDescriptions();
document.addEventListener('shopify:section:load', initTruffleDescriptions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dollie-truffle-landing"] && !Shopify.designMode) return;
  try {
    
function initTruffleLanding() {
  document.querySelectorAll('.tm-v2').forEach(function (section) {
    if (section.dataset.stickyReady) return;
    section.dataset.stickyReady = 'true';
    var hero = section.querySelector('.tm-hero-shell');
    if (!hero || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      section.classList.toggle('tm-sticky-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    });
    observer.observe(hero);
  });
}
initTruffleLanding();
document.addEventListener('shopify:section:load', initTruffleLanding);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dollie-truffle-recipes"] && !Shopify.designMode) return;
  try {
    
const initTruffleDescriptions = () => {
  document.querySelectorAll('.dtr-full-description').forEach(details => {
    if (details.dataset.responsiveReady) return;
    details.dataset.responsiveReady = 'true';
    const desktop = window.matchMedia('(min-width: 768px)');
    details.open = desktop.matches;
    desktop.addEventListener('change', event => { details.open = event.matches; });
  });
};
initTruffleDescriptions();
document.addEventListener('shopify:section:load', initTruffleDescriptions);

  } catch(e) { console.error(e); }
})();
})();
